//Core
import { NgModule }       from '@angular/core';
import { CommonModule }       from '@angular/common';
import { BreadcrumbService } from './breadcrumb.service';

/**
 * /!\ DON'T import this module anywhere else that at the root module
 * in order to correctly share the service between routes
 */
@NgModule({
    imports: [],
    providers: [
        BreadcrumbService,
    ]
})
export class BreadcrumbServiceModule { }
